import React, { useState } from 'react';
import { FaPaw, FaHome, FaImages, FaNewspaper, FaGamepad, FaUsers, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';

const Header = ({ currentPage, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { name: 'Inicio', icon: FaHome, page: 'home' },
    { name: 'Galería', icon: FaImages, page: 'gallery' },
    { name: 'Noticias', icon: FaNewspaper, page: 'news' },
    { name: 'Juegos', icon: FaGamepad, page: 'games' },
    { name: 'Nosotros', icon: FaUsers, page: 'about' },
    { name: 'Contacto', icon: FaEnvelope, page: 'contact' }
  ];

const handleMenuClick = (page, showVideos = false) => {
  setCurrentPage(page);
  setIsMenuOpen(false);
  
  // Si va a la galería, configurar para mostrar videos
  if (page === 'gallery' && showVideos) {
    // Pasar parámetro adicional o usar localStorage temporalmente
    localStorage.setItem('showVideos', 'true');
  }
};

  
  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
{/* Logo */}
<div 
  className="flex items-center space-x-3 cursor-pointer"
  onClick={() => handleMenuClick('home')}
>
  <div className="flex flex-col items-center">
    <div className="flex items-center space-x-2">
<h1 className="text-2xl md:text-3xl font-titulo font-bold bg-gradient-to-r from-sky-500 via-emerald-500 to-teal-500 bg-clip-text text-transparent">        FeelLab
      </h1>
      <span className="text-2xl">🐢</span>
    </div>
    <p className="text-xs text-emerald-600 font-medium italic -mt-1">
      siente, crea, conecta
    </p>
  </div>
</div>

          {/* Menu Desktop */}
          <nav className="hidden md:flex space-x-1">
            {menuItems.map((item, index) => {
              const IconComponent = item.icon;
              const isActive = currentPage === item.page;
              return (
                <button
                  key={index}
                  onClick={() => handleMenuClick(item.page)}
                  className={`flex items-center space-x-2 px-4 py-2 rounded-full font-medium transition-all duration-300 transform hover:scale-105 ${isActive
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-gradient-to-r hover:from-emerald-500 hover:to-teal-500 hover:text-white'
                    }`}
                >
                  <IconComponent className="text-lg" />
                  <span>{item.name}</span>
                </button>
              );
            })}
          </nav>

          {/* Menu Mobile Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 text-white"
          >
            {isMenuOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
          </button>
        </div>

        {/* Menu Mobile */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4">
            <nav className="flex flex-col space-y-2">
              {menuItems.map((item, index) => {
                const IconComponent = item.icon;
                const isActive = currentPage === item.page;
                return (
                  <button
                    key={index}
                    onClick={() => handleMenuClick(item.page)}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-medium transition-all duration-300 ${isActive
                      ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white'
                      : 'text-gray-700 hover:bg-gradient-to-r hover:from-emerald-500 hover:to-teal-500 hover:text-white'
                      }`}
                  >
                    <IconComponent className="text-lg" />
                    <span>{item.name}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;